// App.js or App.tsx
import { BackendProvider} from './Context/BackendContext';
import Main from './Main';

export default function App() {
  return (
    <BackendProvider>
        <Main />
    </BackendProvider>
  );
}